import React, { Fragment, useEffect, useRef, useState } from "react";
import StandardPopup from "./standardPopup";
import GalaxyTabSortableItem from "./galaxyTabSortableItem";
import DeleteModal from "../../../shared/common/deleteModal";
import {
  getLiftOffGalaxyStandard,
  deleteLiftOffGalaxyStandard,
  addLiftOffGalaxyStandard,
} from "../../../../api/liftOffGalaxyStandard.service";
import {
  ILiftOffGalaxyStandard,
  ILiftOffGalaxyTopic,
} from "../../../../model/interface/liftOffGalaxyStandard";
import { connect } from "react-redux";
import constant from "../../../../utils/constant";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Loader from "../../../shared/loader/loader";
import { DownArrowIcon, UpArrowIcon } from "../../../../assets/icons/index";
import {
  IStandardGroupStandardDTO,
  IStandardGroupStandardSearchRequest,
} from "../../../../model/interface/standardGroup";
import { getStandardGroupStandards } from "../../../../api/standardGroup.service";
import { Link } from "react-router";
import Constant from "../../../../utils/constant";
import { IStandardExistsRequest } from "../../../../model/interface/liftOffDiagnosticTest";
import { checkStandardExists } from "../../../../api/liftOffDiagnosticTestQuestion.service";
import { toast } from "react-toastify";

interface GalaxyCardProps {
  liftOffHeaderId: number;
  liftOffGalaxyId: number;
  liftOffGalaxyName: string;
  isLastGalaxyCard: boolean;
  isGalaxyCardSelected: boolean;
  setDisableAddGalaxy: (disable: boolean) => void;
  onClicked: (lfGalaxyId) => void;
  profile: any;
  setSelectedStandards: (
    selectedStandardIds: Array<ILiftOffGalaxyTopic>
  ) => void;
  selectedStandards: Array<ILiftOffGalaxyTopic>;
  selectedStates: Array<number>;
  selectedGrades: Array<number>;
  selectedContentId: number;
  testId: number;
  subjectId: number;
}

const GalaxyCard = (props: GalaxyCardProps) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 9999;
  const [loading, setLoading] = useState(false);
  const [showTopicPopup, setshowTopicPopup] = useState(false);
  const [showSaveOrderFlag, setShowSaveOrderFlag] = useState(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize] = useState(defaultPageSize);
  const [pageNumber] = useState(defaultPageNumber);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteStandard, setDeleteStandard] = useState<any>();
  const [toggle, setToggle] = useState<number>();
  const [galaxyTopics, setGalaxyTopics] = useState<Array<ILiftOffGalaxyTopic>>(
    []
  );
  const [groupedStandards, setGroupedStandards] = useState<
    Array<IStandardGroupStandardDTO>
  >([]);
  const [selectedStandardIds, setSelectedStandardIds] = useState<Array<number>>(
    []
  );
  const [toggleCard, setToggleCard] = useState<boolean>(true);
  const paginationRef: any = useRef(undefined);
  useEffect(() => {
    getData();
  }, [props.liftOffHeaderId, toggleCard, pageNumber, props.liftOffGalaxyId]);

  const getData = () => {
    if (toggleCard) {
      getLiftOffGalaxyStandard(
        props.liftOffHeaderId,
        props.liftOffGalaxyId,
        true,
        pageNumber,
        pageSize
      ).then((r) => {
        setGalaxyTopics(r.data.data);
        setTotalPages(Math.ceil(r.data.totalRecords / pageSize));
        setTotalRecords(r.data.totalRecords);
      });
    }
  };

  const handleTopicPopup = (show: boolean) => {
    setshowTopicPopup(show);
  };

  const handleAddTopic = (
    liftOffGalaxyStandards: Array<ILiftOffGalaxyStandard>
  ) => {
    addLiftOffGalaxyStandard(liftOffGalaxyStandards).then((r) => {
      setLoading(false);
      setShowSaveOrderFlag(false);
      getData();
      handleTopicPopup(false);
      if (
        props.isLastGalaxyCard &&
        props.liftOffGalaxyId !== constant.LIFTOFFGALAXIES.GALAXY8
      ) {
        props.setDisableAddGalaxy(false);
      }
    });
  };

  const confirmDeleteStandard = (standardId: number, orderNo: number) => {
    setShowDeleteModal(true);
    const standard: any = galaxyTopics.find(
      (standard: any) => standard.standardId === standardId
    );
    setDeleteStandard(standard);
  };

  const handleDeleteTopic = () => {
    setLoading(true);
    setShowDeleteModal(false);
    deleteLiftOffGalaxyStandard(deleteStandard)
      .then((r) => {
        if (galaxyTopics.length === 1) {
          paginationRef?.current?.onReset();
        } else {
          getData();
        }
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
    handleShowGroupedStandards(0, 0, "hide");
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || galaxyTopics.length <= 1) return;

    if (active.id !== over.id) {
      const oldIndex = galaxyTopics.findIndex(
        (item, idx) => item.standardId.toString() + "-" + idx === active.id
      );
      const newIndex = galaxyTopics.findIndex(
        (item, idx) => item.standardId.toString() + "-" + idx === over.id
      );

      const tempGalaxyStandards = arrayMove(galaxyTopics, oldIndex, newIndex);
      setGalaxyTopics(tempGalaxyStandards);
      setShowSaveOrderFlag(true);
      handleShowGroupedStandards(0, 0, "hide");
    }
  };

  const handleSaveOrder = () => {
    setLoading(true);
    const liftOffGalaxyStandards = galaxyTopics.map((item, index) => {
      const lfGalaxystandard: ILiftOffGalaxyStandard = {
        liftOffHeaderId: item.liftOffHeaderId,
        standardId: item.standardId,
        liftOffGalaxyId: item.liftOffGalaxyId,
        orderNumber: pageSize * (pageNumber - 1) + index + 1,
        isActive: true,
        isStandardGrouped: item.isStandardGrouped,
        createdByUserId: props.profile?.userId,
        updatedByUserId: props.profile?.userId,
      };
      return lfGalaxystandard;
    });

    handleAddTopic(liftOffGalaxyStandards);
  };

  const handleShowGroupedStandards = async (standardGroupId, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      const groupStandardSearchReq: IStandardGroupStandardSearchRequest = {
        standardGroupId: standardGroupId,
        standardId: 0,
        isActive: true,
      };
      const response = getStandardGroupStandards(
        groupStandardSearchReq,
        1,
        99999
      );
      const data = (await response).data;
      setGroupedStandards(data.data);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  const onStandardSelection = async (
    e,
    standardId,
    isStandardGrouped,
    index
  ) => {
    const isValid = await validateStandard(standardId);
    if (isValid == false) {
      const elem: any = document.getElementById(`${standardId}`);
      if (elem) elem.checked = false;
    } else {
      let ds = [
        ...new Set(props.selectedStandards.map((item) => item.standardId)),
      ];
      if (e.target.checked) {
        if (selectedStandardIds.length) {
          if (!selectedStandardIds.includes(standardId)) {
            ds.push(standardId);
            setSelectedStandardIds(ds);
          } else {
            setSelectedStandardIds(ds);
          }
        } else if (e.target.checked) {
          ds.push(standardId);
          setSelectedStandardIds([standardId]);
        }

        for (let i = 0; i < selectedStandardIds.length; i++) {
          const elem: any = document.getElementById(`${standardId}`);
          if (elem) elem.checked = true;
        }
      }

      if (e.target.checked === false) {
        let removedUnchecked: any = [];
        removedUnchecked = selectedStandardIds.filter((d) => d !== standardId);
        ds = removedUnchecked;
        setSelectedStandardIds(removedUnchecked);
        const elem: any = document.getElementById(`${standardId}`);
        if (elem) elem.checked = false;
      }
      let standards = galaxyTopics.filter(
        (item) => ds.indexOf(item.standardId) !== -1
      );
      standards = props.selectedStandards
        .filter((s) => s.liftOffGalaxyId !== props.liftOffGalaxyId)
        .concat(standards);
      const uniqueStandards = [...new Set(standards.map((item) => item))];
      props.setSelectedStandards(uniqueStandards);

      if (e.target.checked && isStandardGrouped) {
        handleShowGroupedStandards(standardId, index, "show");
      } else if (isStandardGrouped) {
        handleShowGroupedStandards(standardId, index, "hide");
      }
    }
  };

  const validateStandard = async (standardId: number) => {
    let isValid = true;
    const request: IStandardExistsRequest = {
      liftOffDiagnosticTestId: props.testId,
      standardReferenceId: standardId,
      subjectId: props.subjectId,
    };
    const response = checkStandardExists(request);
    const data = (await response).data;
    if (data.standardPresentInTest) {
      toast.error("Standard/Standard Group already added to other heirarchy");
      isValid = false;
      return isValid;
    }
    return isValid;
  };

  return (
    <Fragment>
      <div
        className="mt-6 cursor-pointer bg-gray-50 sm:pr-6 lg:pr-8 lg:flex-shrink-0 lg:border-l lg:border-gray-200 xl:pr-0 shadow border border-gray-200 sm:rounded-lg m-auto"
        onClick={() => {
          props.onClicked(props.liftOffGalaxyId);
        }}
      >
        {loading && <Loader></Loader>}
        <div className="p-4">
          <div className="mb-2 grid grid-cols-2">
            <div className="flex justify-start items-center">
              {!toggleCard && (
                <DownArrowIcon
                  className="h-5 w-5 ml-1 text-gray-500"
                  onClick={() => {
                    setToggleCard(!toggleCard);
                  }}
                />
              )}
              {toggleCard && (
                <UpArrowIcon
                  className="h-5 w-5 ml-1 text-gray-500"
                  onClick={() => {
                    setToggleCard(!toggleCard);
                  }}
                />
              )}
              <h3 className="ml-2">{props.liftOffGalaxyName}</h3>
            </div>

            <div className="flex justify-end">
              {toggleCard && (
                <button
                  className="flex items-center gap-1 py-2 px-3 text-primary-color hover:text-white text-xs bg-transparent hover:bg-primary-color border border-primary-color"
                  onClick={() => {
                    handleTopicPopup(true);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="w-5 m-auto"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  <span>Add Standard</span>
                </button>
              )}
              {!toggleCard && (
                <span> Standards {galaxyTopics ? galaxyTopics.length : 0}</span>
              )}
            </div>
          </div>
          {toggleCard && (
            <Fragment>
              <div className="flex-grow">
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-primary-color">
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider rounded-tl-lg"
                        >
                          <span className="flex">Action</span>
                        </th>
                        <th></th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex"></span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                        >
                          <span className="flex">Order</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">Code</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">Standard / Group</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                        >
                          <span className="flex">Is Grouped</span>
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider rounded-tr-lg"
                        >
                          <span className="flex">Delete</span>
                        </th>
                      </tr>
                    </thead>
                    <SortableContext
                      items={galaxyTopics.map(
                        (item, idx) => item.standardId.toString() + "-" + idx
                      )}
                      strategy={verticalListSortingStrategy}
                    >
                      <tbody>
                        {galaxyTopics &&
                          galaxyTopics.map((topic, index) => (
                            <Fragment key={index}>
                              <GalaxyTabSortableItem
                                topic={topic}
                                index={index}
                                toggle={toggle}
                                onStandardSelection={onStandardSelection}
                                handleShowGroupedStandards={
                                  handleShowGroupedStandards
                                }
                                confirmDeleteStandard={confirmDeleteStandard}
                              />
                              <tr>
                                <td colSpan={8}>
                                  <div
                                    className={`${
                                      index !== toggle ? "hidden" : ""
                                    } px-4 pt-4 pb-2 text-sm text-gray-500`}
                                  >
                                    <div className="shadow border rounded-lg px-3 py-3">
                                      <table className="min-w-full">
                                        <thead>
                                          <tr className="bg-gray-100">
                                            <th
                                              scope="col"
                                              className="inline-flex items-center gap-2 px-3 py-2 pl-6 font-normal text-gray-500 text-xs uppercase text-left tracking-wider"
                                            >
                                              <span className="flex gap-2">
                                                Standard Id
                                              </span>
                                            </th>
                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 font-normal text-xs uppercase text-left text-gray-500 tracking-wider"
                                            >
                                              <span className="flex gap-2">
                                                Code
                                              </span>
                                            </th>
                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 font-normal text-xs uppercase text-left text-gray-500 tracking-wider"
                                            >
                                              <span className="flex gap-2">
                                                Name
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-50">
                                          {groupedStandards.map(
                                            (standard, index) => (
                                              <tr key={index}>
                                                <td className="font-medium pl-6">
                                                  <Link
                                                    to={Constant.EDITSTANDARD.replace(
                                                      ":id",
                                                      standard.standardId
                                                        ? standard.standardId.toString()
                                                        : ""
                                                    )}
                                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                                  >
                                                    {standard.standardId}
                                                  </Link>
                                                </td>
                                                <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                  {standard.standardCode}
                                                </td>
                                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                                  {standard.standardName}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>{" "}
                                  </div>
                                </td>
                              </tr>
                            </Fragment>
                          ))}
                      </tbody>
                    </SortableContext>
                  </table>
                </DndContext>
              </div>

              <div className="flex justify-between items-center m-4">
                {showSaveOrderFlag && (
                  <button
                    className="mt-2 inline-flex items-center float-right text-sm text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    type="button"
                    onClick={() => {
                      handleSaveOrder();
                    }}
                  >
                    Save Order
                  </button>
                )}
              </div>
            </Fragment>
          )}
        </div>
      </div>

      {showTopicPopup && (
        <StandardPopup
          liftOffHeaderId={props.liftOffHeaderId}
          liftOffGalaxyId={props.liftOffGalaxyId}
          orderNumber={totalRecords + 1}
          showPopup={handleTopicPopup}
          handleAddTopic={handleAddTopic}
          availableStates={props.selectedStates}
          availableGrades={props.selectedGrades}
          selectedContentId={props.selectedContentId}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={() => {
            setShowDeleteModal(false);
          }}
          deleteRecord={handleDeleteTopic}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(GalaxyCard);
